import { ServicePath } from "../../constants/apiConstants";
import { QUERY_CACHE_PERIOD } from "../../constants/queryConstants";
import { useFetchQuery } from "../core/rest/useFetchQuery";
import { notificationsKeys } from "./notifications.queryKeys";

/** Poll interval for the unread badge count (10 seconds). */
export const UNREAD_COUNT_POLL_INTERVAL = QUERY_CACHE_PERIOD.VERY_SHORT;

export function useUnreadCount(baseUrl: string | undefined, entityId: string | undefined): number {
  const data = useFetchQuery<{ count: number }>({
    url: `${baseUrl}${ServicePath.GlobalNavNotificationsServiceGraphql}/count?entityId=${entityId}&read=false`,
    queryKey: notificationsKeys.unreadCount(entityId ?? ""),
    options: {
      enabled: !!entityId && !!baseUrl,
      staleTime: QUERY_CACHE_PERIOD.SHORT,
      refetchInterval: UNREAD_COUNT_POLL_INTERVAL,
    },
  });

  return data.data?.count ?? 0;
}
